<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!-- 表格 -->
    <div style="position: relative"
         class="graph-table">
      <component :is="page.selectTable"
                 :class-key="page.tableKey"
                 :number="page.tableNum"
                 :address="page.tableAddress">
      </component>
      <div class="table_min"
           v-if="page.isTableKey"
           v-loading="loading.tableLoading"
           element-loading-background="#FFF"
           element-loading-spinner="el-icon-loading"
           element-loading-customClass="defineLoading"
           element-loading-text="拼命的加载中">
        <component :title="page.tableTitle"
                   :is="page.normalTable"
                   :tableInfo="tableInfo"
                   :devsort-style="tableInfo.devsort">
        </component>
      </div>
    </div>
  </div>

</template>

<script>
import * as queryUtil from "../../../common/query";
import * as Func from "../../../common/commonFun";
import { content } from "./component";
export default {
  components: {
    ...content
  },
  props: {
    page: [Object],
    headerVal: [Object],
    header: [Object],
    newTarget: [Boolean],
    headerShow: [Array]
  },
  data() {
    return {
      loading: {
        tableLoading: false
      },
      // 表格
      tableInfo: {}
    };
  },
  created() {},
  computed: {
    // 公共数据
    queryCommon() {
      return this.$store.state.query_common;
    },
    queryTable() {
      return Object.assign(
        {},
        this.$store.state.query_common,
        this.$store.state.query_table
      );
    }
  },
  watch: {
    queryTable(v) {
      this.getTable(v);
    },
    newTarget() {
      this.getTable(
        Object.assign(
          {},
          this.$store.state.query_common,
          this.$store.state.query_table
        )
      );
    }
  },
  methods: {
    getTable(params) {
      // 正常的有关键指标，也有图表
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        if(this.$route.name.indexOf('_target_manage') === -1){
          params.constantType = this.page.TableconstantType;
        }
        if (this.page.normalTable === "DateTable") {
          Func.getDateTableThree(this, params);
        }
      } else {
        return {};
      }
    }
  }
};
</script>

<style lang="less">
</style>
